import { useState } from 'react';

// import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import {
  FACET_PREFERENCE_SIGNALS,
  trackFacetPreferenceInteraction,
} from '@/services/artworkPreferenceInteraction.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';
import { resetArtworkSearchFilters } from '@/utils/artworkSearchFilters';
import {
  buildFacetPayloadFromSearchQuery,
  diffFacetPayload,
  hasFacetPayloadValues,
} from '@/utils/preferenceSignals';

import SearchFiltersContent from './search-filters-content';

import './index.css';

function SearchFiltersMobile({ query, setQuery, close }) {
  const t = useTranslations('common.shared.search.filters.mobile');
  const [localQuery, setLocalQuery] = useState(query);

  function applyFilters() {
    const nextFacetPayload = buildFacetPayloadFromSearchQuery(localQuery);
    const previousFacetPayload = buildFacetPayloadFromSearchQuery(query);
    const addedFacets = diffFacetPayload(nextFacetPayload, previousFacetPayload);

    if (hasFacetPayloadValues(addedFacets)) {
      trackFacetPreferenceInteraction({
        signal: FACET_PREFERENCE_SIGNALS.SEARCH_FILTER_APPLY,
        source: "search_filters_mobile",
        facets: addedFacets,
      });
    }
    setQuery(localQuery);
    close();
  }

  function resetFilters() {
    setLocalQuery(resetArtworkSearchFilters(localQuery));
  }

  return (
    <>
      <div className="search-filters-mobile__container">
        <div className="search-filters-mobile__header">
          <button
            type="button"
            className="search-filters-mobile__header-reset"
            onClick={resetFilters}>
            {t('reset')}
          </button>

          <Text className="search-filters-mobile__header-text" >
            {t('title')}
          </Text>

          <XIcon className="search-filters-mobile__header-close" onClick={close}/>
        </div>

        <div className="search-filter-mobile__content-outter">
          <div className="search-filters-mobile__content">
            <SearchFiltersContent 
              query={localQuery} 
              setQuery={setLocalQuery} 
              isMobile
            />
          </div>
        </div>

        <div className="search-filters-mobile__apply-container">
          <ContinueButton className="search-filters-mobile__apply-button" onClick={applyFilters}>
            {t('apply')}
          </ContinueButton>
        </div>
      </div>
    </>
  );
}

export default function SearchFilters({ query, setQuery, open, close }) {
  return (
    <>
      <PopupToBottomSheet 
        className="search-filters-bottom-sheet element-non-selectable" 
        open={open} 
        close={close}
        popupOptions={{ darkerBlur: true }}      
      >
        <SearchFiltersMobile 
          query={query} 
          setQuery={setQuery} 
          close={close}
        />
      </PopupToBottomSheet>
    </>
  );
  // }
}
